$(window).ready(function(){

	function init(){
		transition();

		window.setTimeout(function(){
			initWow();
			$('.wow').css('opacity', '1');
		}, 1000);

		clamp();

		$(window).resize(function(){
			clamp();
		});

		mobileMenu();

		homeslider();
		productslider();
		brandslider();
		imagePopup();
		contact();
		popup();
	}

	function popup(){
		$('.close-popup').click(function(e){
			$('#popup').remove();
		});
	}

	function mobileMenu(){
		$('.menubutton').click(function(e){
			$('nav').toggleClass('open');

			if($('nav').hasClass('open')){
				$('#wrapper').css('height', '100vh');
				$('#wrapper').css('overflow', 'hidden');
			}else{
				$('#wrapper').css('height', 'auto');
				$('#wrapper').css('overflow', 'auto');
			}
		});

		$('nav a.services').click(function(e){
			e.preventDefault();
			$('.submenu').toggleClass('open');
		});
	}

	function imagePopup(){
		$('#images').magnificPopup({
			delegate: '.image',
			type: 'image',
			tLoading: '',
			mainClass: 'mfp-img-mobile',
			gallery: {
				enabled: true,
				navigateByImgClick: true,
				preload: [1,1] // Will preload 0 - before current, and 1 after the current image
			},
			image: {
				tError: '<a href="%url%">De afbeelding</a>kon niet geladen worden.',
				titleSrc: function(item) {
					return item.el.attr('title');
				}
			}
		});
	}

	function transition(){
		$(".animsition").animsition({
		    inClass: 'zoom-in-sm',
		    outClass: 'zoom-out-sm',
		    inDuration: 750,
		    outDuration: 750,
		    linkElement: 'h1[onclick],.close-cookies:not,a:not([href*="tel:"]):not([href*="#"]):not([href*="mailto:"]):not([target="_blank"])',
		    loading: false,
		    loadingParentElement: 'body',
		    loadingClass: 'animsition-loading',
		    loadingInner: '',
		    timeout: false,
		    timeoutCountdown: 5000,
		    onLoadEvent: true,
		    browser: [ 'animation-duration', '-webkit-animation-duration'],
		    unSupportCss: ["animation-duration", "-webkit-animation-duration", "-o-animation-duration"],
		    transition: function(url){ window.location.href = url; }
  		});
	}

	function initWow(){
		if($(window).width() < 500){
			new WOW({
				offset: 50,

			}).init();
		}else{
			new WOW({
				offset: 100
			}).init();
		}
	}

	function clamp(){
		$('.clamp-1').each(function(index, element) {
		    $clamp(element, { clamp: 1, useNativeClamp: false });
		});

		$('.clamp-2').each(function(index, element) {
		    $clamp(element, { clamp: 2, useNativeClamp: false });
		});

		$('.clamp-3').each(function(index, element) {
		    $clamp(element, { clamp: 3, useNativeClamp: false });
		});

		$('.clamp-4').each(function(index, element) {
		    $clamp(element, { clamp: 3, useNativeClamp: false });
		});
	}

	function homeslider(){
		$('#homeslider').flexslider({
			animation: "slide",
			controlNav: false,
			directionNav: false,
			animationLoop: true,
			slideshow: true,
			touch: false,
			slideshowSpeed: 6000,
		});


		$('.arrows .prev').on('click', function(){
		    $('#homeslider').flexslider('prev');
		    return false;
		});

		$('.arrows .next').on('click', function(){
		    $('#homeslider').flexslider('next');
		    return false;
		});
	}

	function productslider(){
		$('#productslider').flexslider({
			animation: "slide",
			controlNav: false,
			directionNav: false,
			animationLoop: true,
			slideshow: true,
			touch: false,
			slideshowSpeed: 6000,
		});


		$('.arrows .prev').on('click', function(){
		    $('#productslider').flexslider('prev');
		    return false;
		});

		$('.arrows .next').on('click', function(){
		    $('#productslider').flexslider('next');
		    return false;
		});
	}

	function brandslider(){
		var items = 4;

		if($(window).width() < 768){
			items = 2;
		}

		$('.brands').flexslider({
			animation: "slide",
			controlNav: false,
			directionNav: false,
			animationLoop: true,
			slideshow: true,
			touch: true,
			slideshowSpeed: 6000,
			itemWidth: 150,
			minItems: items,
			maxItems: items
		});
	}

	function contact(){
		$('#contact-form').on('submit', function(e){
			e.preventDefault();
			$('#contact-form .message').addClass('hidden');
			$('#contact-form .data').addClass('loading');
			$.post($('#contact-form').attr('action'),$('#contact-form').serialize(), function(response){
				$('#contact-form .data').removeClass('loading');
				if(response == 'true'){
					$('#contact-form .success-message').removeClass('hidden');
					$('#contact-form .data').addClass('hidden');
					window.history.pushState('', '', '/nl/contact/bedankt');
                 	ga('send', 'pageview', '/nl/contact/bedankt');
                 	gtag('config', 'UA-60910507-9', {'page_path': '/nl/contact/bedankt'});
				}else{
					$('#contact-form .error-message').removeClass('hidden');
				}
	        });
		});
	}

	init();
});
